import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/common/PageHeader";
import PageMeta from "../components/common/PageMeta";
import FooterOne from "../layout/Footer/FooterOne";
import Navbar from "../layout/Header/Navbar";
import Layout from "../layout/Layout";
import { useLanguage } from "../context/LanguageContext";


const Cases = () => {
  const { t, language } = useLanguage();
  

  const cases = [
    {
      id: 'rightee',
      title: 'Rightee',
      description: t('cases.products.0.description'),
      image: '/assets/img/rightee2.png',
      link: '/cases/rightee',
      category: language === 'pt' ? 'Mobile App' : 'Mobile App'
    },
    {
      id: 'cardiohome',
      title: 'Cardiohome',
      description: t('cases.products.1.description'),
      image: '/assets/img/cardiohome.png',
      link: '/cases/cardiohome',
      category: language === 'pt' ? 'Plataforma de Saúde' : 'Healthcare Platform'
    },
    {
      id: 'grupovisco',
      title: 'Grupo Visco',
      description: language === 'pt' 
        ? 'CRM, Painel BI e automação de negócios para o maior laboratório ótico do Brasil.'
        : 'CRM, BI Panel, and business automation for Brazil\'s largest optical laboratory.',
      image: '/assets/img/grupovisco.png',
      link: '/cases/grupovisco',
      category: language === 'pt' ? 'Automação de Negócios' : 'Business Automation'
    }
    
  ];

  return (
    <Layout>
      <PageMeta title={t('navbar.cases.cases')} />
      <Navbar classOption="navbar-light" />
      <PageHeader 
        title={t('navbar.cases.cases')} 
        desc={t('navbar.cases.title')} 
      />

      <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title text-center mt-5 mb-5">
                <h2>{t('navbar.cases.title')}</h2>
                <p className="text-muted">
                  {language === 'pt' 
                    ? 'Conheça alguns dos nossos projetos mais impactantes'
                    : 'Discover some of our most impactful projects'
                  }
                </p>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {cases.map((caseItem) => (
              <div key={caseItem.id} className="col-lg-6 col-xl-3">
                <div className="card h-100 border-0 shadow-sm d-flex flex-column">
                  <div className="card-body p-4 d-flex flex-column">
                    <div className="text-center mb-3">
                      <img 
                        src={caseItem.image} 
                        alt={caseItem.title}
                        className="img-fluid"
                        style={{ maxHeight: '80px', objectFit: 'contain' }}
                      />
                    </div>
                    <div className="mb-2">
                      <span className="badge bg-primary-subtle text-primary fs-6">
                        {caseItem.category}
                      </span>
                    </div>
                    <h5 className="card-title mb-3">{caseItem.title}</h5>
                    <p className="card-text text-muted mb-4 flex-grow-1" style={{ minHeight: '60px' }}>
                      {caseItem.description}
                    </p>
                    <Link 
                      to={caseItem.link} 
                      className="btn btn-outline-primary w-100 mt-auto"
                    >
                      {language === 'pt' ? 'Ver Case Completo' : 'View Full Case'}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row mt-5">
            <div className="col-12 text-center">
              <div className="section-title">
                <h3>{language === 'pt' ? 'Quer ver mais cases?' : 'Want to see more cases?'}</h3>
                <p className="text-muted mb-4">
                  {language === 'pt' 
                    ? 'Temos muitos outros projetos incríveis para mostrar'
                    : 'We have many other amazing projects to show'
                  }
                </p>
                <Link to="/request-demo" className="btn btn-primary btn-lg">
                  {t('navbar.contact')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne footerLight />
    </Layout>
  );
};

export default Cases; 